/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import api from "../../../services/api";
import { styled } from "styled-components";
import React, { useCallback, useEffect, useState } from "react";
import { useAppSelector } from "../../../store/hooks";
import ModalForm from "../../../components/modal-form";
import { TipoFormulario } from "../../../services/constantes";
import { Coluna, ConfiguracaoBanda, FormatoRelatorio, Relatorio } from "../../../components/relatorio";
import { RelatorioCard } from "../../../components/relatorio-card";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import { useFiliais } from "../../../hooks/useFiliais";
import { montarObservacaoRelatorio } from "./montarObservacaoRelatorio";
import { obterIdTenent, obterNomeEmpresa, obterNomeUsuario, usuarioTemPermissao } from "../../../services/seguranca";
import { ConverterEscolhaRelatorioVeiculosSituacaoParaTexto, converterPeriodicidadePagamentoParaTexto, converterStatusLocacaoParaTexto, formatDateToISOWithZeroTime, formatarData, formatarDataHora, formatarParaReais, tratarErroApi } from "../../../services/utilitarios";
import { ApiError, Campo, ContextoRelatorioLocacoes, ContextoRelatorioServicoVeiculo, ContextoRelatorioVeiculos, Opcao, RelatorioLocacoes, RelatorioServicoVeiculo, RelatorioVeiculos, StatusLocacao, TipoModoVisualizacaoRelatorio, TipoOrdenacaoRelatorio, TpEscolhaRelatorioVeiculosSituacao, TpRelatorioGeral } from "../../../services/tipos";
import ProgressBarModal from "../../../components/progressbar-relatorio";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import ModalRelatorioLocacao from "../../../components/modal-relatorio-locacao";
import ModalEscolhaFormatoRelatorio from "../../../components/modal-escolha-formato-relatorio";
import { Modal, Button, Form } from "react-bootstrap";

// O backend só lê lista na query como idFiliais=a&idFiliais=b. O padrão do axios (idFiliais[]=a)
// chegava vazio e o relatório ignorava as unidades escolhidas.
const LISTAS_NA_QUERY = { indexes: null };

const ModalAlertaLaudo: React.FC<{ show: boolean; locacoes: Opcao[]; onClose: () => void; onSelecionar: (id: string) => void }> = ({ show, locacoes, onClose, onSelecionar }) => {
  const [idSelecionado, setIdSelecionado] = React.useState('');
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton style={{ backgroundColor: '#1E3A5F', color: 'white' }}>
        <Modal.Title style={{ fontSize: '1.05rem' }}>Selecionar Locação</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '1.5rem' }}>
        <Form.Label style={{ fontSize: '0.85rem', color: '#64748B', marginBottom: '0.5rem' }}>
          Escolha a locação para gerar o laudo:
        </Form.Label>
        <Form.Control as="select" value={idSelecionado} onChange={(e: any) => setIdSelecionado(e.target.value)}
          style={{ height: '40px', fontSize: '0.9rem' }}>
          <option value="">Selecione uma locação...</option>
          {locacoes.map((loc: any) => (
            <option key={String(loc.valor)} value={String(loc.valor)}>{loc.label}</option>
          ))}
        </Form.Control>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>Cancelar</Button>
        <Button disabled={!idSelecionado} onClick={() => onSelecionar(idSelecionado)}
          style={{ backgroundColor: '#1E3A5F', border: 'none' }}>
          Gerar Relatório
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const ContainerRelatorioCard = styled.div`
  gap: 10px;
  width: auto;
  display: grid;
  margin: 20px;
  grid-template-columns: repeat(5, 1fr);
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 2fr));
  }
`;

const Title = styled.h1`
  font-size: 18px;
  font-weight: 500;
  color: #666;
  margin-top: 20px;
  margin-left: 20px;
`;

function RelatorioGeral() {
  const [veiculo, setVeiculo] = useState('TODOS');
  const [carregando, setCarregando] = useState(false);
  const [dataFinal, setDataFinal] = useState<string>();
  const [reportTrigger, setReportTrigger] = useState(0);
  const [totalPecas, setTotalPecas] = useState<number>(0);
  const [dataInicial, setDataInicial] = useState<string>();
  const [valorInicial, setValorInicial] = useState<number>();
  const [valorFinal, setValorFinal] = useState<number>();
  const [totalServico, setTotalServico] = useState<number>(0);
  const [totalEmManutencao, setTotalManutencao] = useState<number>(0);
  const [exibirContexto, setExibirContexto] = useState(false);
  const [statusLocacao, setStatusLocacao] = useState<string>('');
  const [veiculosOpcoes, setVeiculosOpcoes] = useState<Opcao[]>([]);
  const [forcarAtualizacao, setForcarAtualizacao] = useState(false);
  const [entidadeAtualizacao, setEntidadeAtualizacao] = useState<any>({});
  const [dadosRelatorioLocacao, setDadosRelatorioLocacao] = useState<any[]>([]);
  const [dadosRelatorioVeiculos, setDadosRelatorioVeiculos] = useState<any[]>([]);
  const [prestadorDeServicoOpcoes, setPrestadorDeServicoOpcoes] = useState<Opcao[]>([]);
  const [relatorio, setRelatorio] = useState<TpRelatorioGeral>(TpRelatorioGeral.Nenhum);
  const [dadosRelatorioServicoVeiculo, setDadosRelatorioServicoVeiculo] = useState<any[]>([]);
  const [modoVisualizacaoRelatorio, setModoVisualizacaoRelatorio] = useState<TipoModoVisualizacaoRelatorio>(TipoModoVisualizacaoRelatorio.Detalhado);
  const [formatoRelatorio, setFormatoRelatorio] = useState<FormatoRelatorio>('pdf');
  const [exibirEscolhaFormato, setExibirEscolhaFormato] = useState(false);
  const entidadeRelatorioPendente = React.useRef<any>(null);
  const [situacao, setSituacao] = useState<TpEscolhaRelatorioVeiculosSituacao>(TpEscolhaRelatorioVeiculosSituacao.Todos);
  const [totalInvestido, setTotalInvestido] = useState(0);
  const [showLaudoLocacao, setShowLaudoLocacao] = useState(false);
  const [locacaoParaLaudo, setLocacaoParaLaudo] = useState<any>(null);
  const [locacoesParaLaudo, setLocacoesParaLaudo] = useState<Opcao[]>([]);
  const [mostrarAvancadoRelatorio, setMostrarAvancadoRelatorio] = useState(false);
  const [filiaisEscolhidas, setFiliaisEscolhidas] = useState<any[]>([]);

  const { empresaTemFiliais, filiaisOptions, labelComFilial, filialSelecionada, getNomeFilial } = useFiliais();
  const token = useAppSelector(state => state.token);

  const tratarErro = useCallback((error: AxiosError<ApiError>) => {
    setCarregando(false);
    const errorMessage = error.response?.data?.Mensagem || 'Erro desconhecido';
    toast.error(`Não foi possível continuar a operação Relatório: ${errorMessage}`);
  }, []);

  const fetchVeiculos = async () => {
    if (!usuarioTemPermissao(token, 'veiculo_visualizar')) return;
    setCarregando(true);
    try {
      const response = await api.get(`/VeiculoPorEmpresa/${obterIdTenent(token)}`);
      const novasOpcoes = response.data.map((veiculo: any) => ({
        valor: veiculo.id,
        label: labelComFilial(`${veiculo.placa}:  ${veiculo.marca} ${veiculo.modelo} ${veiculo.ano}`, veiculo.idFilial),
      }));
      setVeiculosOpcoes(novasOpcoes);
    } catch (error: any) {
      tratarErro(error);
    } finally {
      setCarregando(false);
    }
  };

  const fetchPrestadorServico = async () => {
    if (!usuarioTemPermissao(token, 'prestadorservico_visualizar')) return;
    setCarregando(true);
    try {
      const response = await api.get(`/PrestadorServicosPorEmpresa/${obterIdTenent(token)}`);
      const novasOpcoes = response.data.map((prestadorServico: any) => ({
        valor: prestadorServico.id,
        label: `${prestadorServico.documento} - ${prestadorServico.nome}`,
      }));
      setPrestadorDeServicoOpcoes(novasOpcoes);
    } catch (error: any) {
      tratarErro(error);
    } finally {
      setCarregando(false);
    }
  };

  const buscarRelatorioServicoVeiculo = async (contexto: ContextoRelatorioServicoVeiculo) => {
    setCarregando(true);
    try {
      const response = await api.get('/Relatorio/ServicoVeiculo', { params: contexto, paramsSerializer: LISTAS_NA_QUERY });
      const dadosFormatados: RelatorioServicoVeiculo[] = response.data.map((d: any) => {
        const totalServicos = d.servicoVeiculoServicos.reduce((soma: number, s: any) => soma + Number(s.valor), 0);
        const totalPecas = d.servicoVeiculoPecas.reduce((soma: number, p: any) => soma + Number(p.valor * p.quantidadeUsada), 0);

        return {
          valor: `${formatarParaReais(d.valor)}`,
          hodometro: d.hodometro,
          descricao: `${d.descricao}`,
          dataRealizado: formatarData(new Date(d.dataRealizado)),
          prestadorServico: `${d.prestadorDeServico.documento} - ${d.prestadorDeServico.nome}`,
          veiculo: `${d.veiculo.placa} - ${d.veiculo.marca} - ${d.veiculo.modelo} - ${d.veiculo.ano}`,
          servicos: d.servicoVeiculoServicos.map((s: any) => ({
            servico: {
              nome: s.servico.nome,
              valor: formatarParaReais(Number(s.valor)),
            },
          })),
          pecas: d.servicoVeiculoPecas.map((p: any) => ({
            peca: {
              nome: p.peca.nome,
              marca: p.peca.marca,
              modelo: p.peca.modelo,
            },
            valorUnidade: formatarParaReais(p.valor),
            valor: formatarParaReais(p.valor * p.quantidadeUsada),
            quantidadeUsada: p.quantidadeUsada,
            provenienteDoEstoque: String(p.provenienteDoEstoque).toUpperCase()
          })),
          valorTotalServico: formatarParaReais(totalServicos),
          valorTotalPeca: formatarParaReais(totalPecas)
        };
      });

      const totalEmServico = response.data.reduce((acc: number, d: any) => {
        const totalServicos = d.servicoVeiculoServicos.reduce((soma: number, s: any) => soma + Number(s.valor), 0);
        return acc + totalServicos;
      }, 0);

      const totalEmPecas = response.data.reduce((acc: number, d: any) => {
        const totalPecas = d.servicoVeiculoPecas.reduce((soma: number, p: any) => soma + Number(p.valor * p.quantidadeUsada), 0);
        return acc + totalPecas;
      }, 0);


      const totalEmManutencoes = response.data.reduce((acc: any, d: any) => acc + Number(d.valor), 0);

      setTotalManutencao(totalEmManutencoes);
      setTotalServico(totalEmServico);
      setTotalPecas(totalEmPecas);
      setDadosRelatorioServicoVeiculo(dadosFormatados);
      setReportTrigger(prev => prev + 1);
    } catch (error: any) {
      tratarErro(error);
    } finally {
      setCarregando(false);
    }
  };

  const buscarRelatorioLocacoes = async (contexto: ContextoRelatorioLocacoes) => {
    setCarregando(true);
    try {
      const response = await api.get('/Relatorio/Locacoes', { params: contexto, paramsSerializer: LISTAS_NA_QUERY });
      const dadosFormatados: RelatorioLocacoes[] = response.data.map((d: any) => ({
        kmInicial: d.kmInicial,
        valorCaucao: `${formatarParaReais(d.valorCaucao)}`,
        valorAluguel: `${formatarParaReais(d.valorAluguel)}`,
        tempoContratoEmMeses: d.tempoContratoEmMeses,
        dataInicio: formatarDataHora(d.dataInicio),
        dataTermino: d.dataTermino ? formatarDataHora(d.dataTermino) : '—',
        status: `${converterStatusLocacaoParaTexto(d.status)}`,
        locatario: `${d.locatario.documento} - ${d.locatario.nome}`,
        veiculo: `${d.veiculo.placa} - ${d.veiculo.marca} - ${d.veiculo.modelo} - ${d.veiculo.ano}`,
        periodicidadePagamento: `${converterPeriodicidadePagamentoParaTexto(d.periodicidadePagamento)}`,
        opcaoDeCompra: d.opcaoDeCompra ? "Sim" : "Não",
        observacao: montarObservacaoRelatorio(d)
      }));

      setDadosRelatorioLocacao(dadosFormatados);
      setReportTrigger(prev => prev + 1);
    } catch (error: any) {
      tratarErro(error);
    } finally {
      setCarregando(false);
    }
  };

  const buscarRelatorioVeiculos = async (contexto: ContextoRelatorioVeiculos) => {
    setCarregando(true);
    try {
      const params: any = { ...contexto };
      if (!params.dataInicial) delete params.dataInicial;
      if (!params.dataFinal) delete params.dataFinal;
      const response = await api.get('/Relatorio/Veiculos', { params, paramsSerializer: LISTAS_NA_QUERY });

      const totalInvestido = response.data.reduce(
        (soma: number, d: any) => soma + d.investimento,
        0
      );

      const dadosFormatados: RelatorioVeiculos[] = response.data.map((d: any) => ({
        placa: d.placa,
        marca: d.marca,
        modelo: d.modelo,
        ano: d.ano,
        cor: d.cor,
        investimento: formatarParaReais(d.investimento),
        dataCompra: formatarData(new Date(d.dataCompra)),
        situacao: d.situacao,
      }));

      setDadosRelatorioVeiculos(dadosFormatados);

      setTotalInvestido(totalInvestido);

      setReportTrigger(prev => prev + 1);
    } catch (error: any) {
      tratarErro(error);
    } finally {
      setCarregando(false);
    }
  };


  const colunasRelatorio: Coluna[] = relatorio ===
    TpRelatorioGeral.ServicoVeiculo ? [
    { propriedade: "veiculo", titulo: "Veículo" },
    { propriedade: "prestadorServico", titulo: "Prest. Serviço" },
    { propriedade: "descricao", titulo: "Descrição" },
    { propriedade: "dataRealizado", titulo: "Data" },
    { propriedade: "hodometro", titulo: "Hodômetro" },
    { propriedade: "valorTotalPeca", titulo: "Vr Peças" },
    { propriedade: "valorTotalServico", titulo: "Vr Serviços" },
    { propriedade: "valor", titulo: "Vr Total" },
  ] : relatorio === TpRelatorioGeral.Locacao ? [
    { propriedade: "locatario", titulo: "Locatário" },
    { propriedade: "veiculo", titulo: "Veículo" },
    { propriedade: "dataInicio", titulo: "Data início" },
    { propriedade: "dataTermino", titulo: "Data Termino" },
    { propriedade: "kmInicial", titulo: "Hodômetro Inicial" },
    { propriedade: "status", titulo: "Status" },
    { propriedade: "valorAluguel", titulo: "Aluguel" },
    { propriedade: "valorCaucao", titulo: "Valor Caução" },
    { propriedade: "periodicidadePagamento", titulo: "Periodicidade Pagamento" },
    { propriedade: "tempoContratoEmMeses", titulo: "Tempo Contrato (Meses)" },
    { propriedade: "opcaoDeCompra", titulo: "Opção de Compra" },
    { propriedade: "observacao", titulo: "Observação" },
  ] : relatorio === TpRelatorioGeral.Veiculo ? [
    { propriedade: "placa", titulo: "Placa" },
    { propriedade: "marca", titulo: "Marca" },
    { propriedade: "modelo", titulo: "Modelo" },
    { propriedade: "ano", titulo: "Ano" },
    { propriedade: "cor", titulo: "Cor" },
    { propriedade: "situacao", titulo: "Situação" },
    { propriedade: "investimento", titulo: "Investimento" },
    { propriedade: "dataCompra", titulo: "Data Compra" },
    { propriedade: "observacao", titulo: "Observação" },
  ] : [];

  const fonteDeDados =
    relatorio === TpRelatorioGeral.ServicoVeiculo ? dadosRelatorioServicoVeiculo :
      relatorio === TpRelatorioGeral.Locacao ? dadosRelatorioLocacao :
        relatorio === TpRelatorioGeral.Veiculo ? dadosRelatorioVeiculos :
          [];

  const tituloRelatorio =
    relatorio === TpRelatorioGeral.ServicoVeiculo ? "Manutenções" :
      relatorio === TpRelatorioGeral.Locacao ? "Locações" :
        relatorio === TpRelatorioGeral.Veiculo ? "Veículos" :
          "";

  const filialRelatorioTexto = empresaTemFiliais
    ? ` | Unidade: ${filiaisEscolhidas.length > 0
      ? filiaisEscolhidas.map((f: any) => f.nome).join(', ')
      : (filialSelecionada ? getNomeFilial(filialSelecionada) : 'Todas as unidades')}`
    : '';

  let subTituloRelatorio = '';
  if (relatorio === TpRelatorioGeral.ServicoVeiculo) {
    subTituloRelatorio = `Veículo: ${veiculo || 'TODOS'} | Período de Emissão ${dataInicial} à ${dataFinal}${filialRelatorioTexto}`;
  } else if (relatorio === TpRelatorioGeral.Locacao) {
    subTituloRelatorio = `Veículo: ${veiculo || 'TODOS'} | Status: ${statusLocacao || 'TODOS'} | Período de Emissão ${dataInicial} à ${dataFinal}${filialRelatorioTexto}`;
  } else if (relatorio === TpRelatorioGeral.Veiculo) {
    const filtroValor = valorInicial && valorFinal
      ? `Valor R$ ${valorInicial} à R$ ${valorFinal} | `
      : '';
    const filtroPeriodo = dataInicial && dataFinal
      ? `Período de Compra ${dataInicial} à ${dataFinal} | `
      : '';
    const textoSituacao = `Situação: ${ConverterEscolhaRelatorioVeiculosSituacaoParaTexto(situacao).toUpperCase()}`;
    subTituloRelatorio = `${filtroPeriodo}${filtroValor}${textoSituacao}${filialRelatorioTexto}`;
  }

  let rodapeRelatorio: string[] = [];

  if (relatorio === TpRelatorioGeral.ServicoVeiculo) {
    rodapeRelatorio = [
      `Total Serviços: ${formatarParaReais(totalServico)}`,
      `Total Peças: ${formatarParaReais(totalPecas)}`,
      `Total Manutenções: ${formatarParaReais(totalEmManutencao)}`,
    ];
  } else if (relatorio === TpRelatorioGeral.Veiculo) {
    rodapeRelatorio = [`Total Investido: ${formatarParaReais(totalInvestido)}`];
  }


  const obterMesAnteriorAHoje = (): Date => {
    const hoje = new Date();
    hoje.setMonth(hoje.getMonth() - 1);
    return hoje;
  };

  const dataMesAnterior: Date = obterMesAnteriorAHoje();

  const onSave = (e: any) => {
    if ((e['dataInicial'] && e['dataFinal']) && (e['dataInicial'] > e['dataFinal'])) {
      toast.info('A data final deve ser maior (posterior) a data inicial.')
      return;
    }

    // Guarda os dados do formulário e abre o modal de escolha de formato.
    // A geração real (handleBuscar...) só roda após o usuário confirmar PDF ou XLSX.
    entidadeRelatorioPendente.current = e;
    setExibirEscolhaFormato(true);
  };

  const dispararGeracaoRelatorio = (formato: FormatoRelatorio) => {
    setFormatoRelatorio(formato);
    setExibirEscolhaFormato(false);
    setExibirContexto(false);

    const e = entidadeRelatorioPendente.current;
    if (!e) return;
    entidadeRelatorioPendente.current = null;

    if (relatorio === TpRelatorioGeral.ServicoVeiculo) {
      const contexto: ContextoRelatorioServicoVeiculo = {
        dataFinal: e['dataFinal'],
        idVeiculo: e['idVeiculo'],
        valorFinal: e['valorFinal'],
        dataInicial: e['dataInicial'],
        valorInicial: e['valorInicial'],
        idEmpresa: obterIdTenent(token),
        idPrestadorDeServico: e['idPrestadorDeServico'],
        ordenacao: e['ordenacao'] || TipoOrdenacaoRelatorio.MaisRecenteParaMaisAntigo,
        ...(filiaisEscolhidas.length > 0 && { idFiliais: filiaisEscolhidas.map((f: any) => f.id) }),
      };
      handleBuscarRelatorioServicoVeiculo(contexto);
    } else if (relatorio === TpRelatorioGeral.Locacao) {
      const contexto = {
        idVeiculo: e['idVeiculo'],
        idEmpresa: obterIdTenent(token),
        status: e['status'] || StatusLocacao.Nenhum,
        opcaoDeCompra: e['opcaoDeCompra'] || null,
        ...(e['dataInicial'] ? { dataInicial: e['dataInicial'] } : {}),
        ...(e['dataFinal'] ? { dataFinal: e['dataFinal'] } : {}),
        ...(e['vigenteEm'] ? { vigenteEm: e['vigenteEm'] } : {}),
        ...(filiaisEscolhidas.length > 0 && { idFiliais: filiaisEscolhidas.map((f: any) => f.id) }),
      };
      handleBuscarRelatorioLocacoes(contexto);
    } else if (relatorio === TpRelatorioGeral.Veiculo) {
      const contexto = {
        dataFinal: e['dataFinal'],
        dataInicial: e['dataInicial'],
        valorInicial: e['valorInicial'] | 0,
        valorFinal: e['valorFinal'] | 0,
        situacao: e['situacao'],
        ...(e['finalPlaca']?.trim() ? { finalPlaca: e['finalPlaca'].trim() } : {}),
        idEmpresa: obterIdTenent(token),
        ...(filiaisEscolhidas.length > 0 && { idFiliais: filiaisEscolhidas.map((f: any) => f.id) }),
      };
      handleBuscarRelatorioVeiculos(contexto);
    }
  };

  const contexto: Campo[] = relatorio === TpRelatorioGeral.ServicoVeiculo ? [
    { coluna: 1, label: 'Data Inicial', largura: 6, nome: 'dataInicial', tipo: 'date', linha: 1, required: true, visible: true },
    { coluna: 2, label: 'Data Final', largura: 6, nome: 'dataFinal', tipo: 'date', linha: 1, required: true, visible: true },
    { coluna: 1, label: 'Veículo', largura: 6, nome: 'idVeiculo', tipo: 'select', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, opcoes: veiculosOpcoes },
    { coluna: 2, label: 'Prestador de Serviço', largura: 6, nome: 'idPrestadorDeServico', tipo: 'select', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, opcoes: prestadorDeServicoOpcoes },
    { coluna: 1, label: 'Valor inicial', largura: 6, nome: 'valorInicial', tipo: 'money', linha: 3, required: false, visible: true },
    { coluna: 2, label: 'Valor final', largura: 6, nome: 'valorFinal', tipo: 'money', linha: 3, required: false, visible: true },
    {
      coluna: 1, label: 'Ordenação', largura: 6, nome: 'ordenacao', tipo: 'select', selectBoxIsCleareable: true, linha: 4, required: false, visible: true,
      opcoes: [
        { label: "Mais recente para o mais antigo", valor: TipoOrdenacaoRelatorio.MaisRecenteParaMaisAntigo },
        { label: "Mais antigo para o mais recente", valor: TipoOrdenacaoRelatorio.MaisAntigoParaMaisRecente },
      ], apenasLeitura: false
    },
    {
      coluna: 2, label: 'Modo de Visualização', largura: 6, nome: 'modoVisualizacao', tipo: 'select', selectBoxIsCleareable: true, linha: 4, required: false, visible: true,
      opcoes: [
        { label: "Compacto", valor: TipoModoVisualizacaoRelatorio.Compacto },
        { label: "Detalhado", valor: TipoModoVisualizacaoRelatorio.Detalhado },
      ], apenasLeitura: false, onCampoSair(e: TipoModoVisualizacaoRelatorio) {
        setModoVisualizacaoRelatorio(e)
      },
    },
    {
      label: '', nome: '_toggleAvancadoServico', tipo: 'custom', required: false,
      largura: 12, coluna: 1, linha: 5, visible: true,
      component: () => (
        <button
          type="button"
          onClick={() => setMostrarAvancadoRelatorio(!mostrarAvancadoRelatorio)}
          style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
        >
          {mostrarAvancadoRelatorio ? 'Ocultar opções avançadas' : 'Mostrar filtros avançados'}
        </button>
      ),
    },
    {
      coluna: 1, label: 'Unidade', largura: 6, nome: 'filiais', tipo: 'multiselect', selectBoxIsCleareable: true, linha: 6, required: false,
      visible: () => mostrarAvancadoRelatorio && empresaTemFiliais,
      selectMultiProps: {
        dataSource: filiaisOptions.map(f => ({ id: f.valor, nome: f.label })),
        onSelectionChange: ((data: any) => {
          setFiliaisEscolhidas(data);
        }),
        optionLabelField: 'nome',
        height: '200px',
        modo: TipoFormulario.tpCadastro,
        initialSelected: [],
        criticarRepeticao: true,
        orderByField: "nome",
        multiValueBackground: "#1F467E",
      },
    },
  ] : relatorio === TpRelatorioGeral.Locacao ? [
    { coluna: 1, label: 'Data Inicial', largura: 6, nome: 'dataInicial', tipo: 'date', linha: 1, required: false, visible: true, subLabel: 'Opcional — filtra por início da locação' },
    { coluna: 2, label: 'Data Final', largura: 6, nome: 'dataFinal', tipo: 'date', linha: 1, required: false, visible: true },
    { coluna: 1, label: 'Veículo', largura: 6, nome: 'idVeiculo', tipo: 'select', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, opcoes: veiculosOpcoes },
    {
      coluna: 2, label: 'Status', largura: 6, nome: 'status', tipo: 'select', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, opcoes: [
        { label: String(converterStatusLocacaoParaTexto(StatusLocacao.Ativa)), valor: StatusLocacao.Ativa },
        { label: String(converterStatusLocacaoParaTexto(StatusLocacao.Inativa)), valor: StatusLocacao.Inativa },
        { label: String(converterStatusLocacaoParaTexto(StatusLocacao.Encerrada)), valor: StatusLocacao.Encerrada },
      ]
    },
    { coluna: 1, label: 'Locação vigente em', largura: 6, nome: 'vigenteEm', tipo: 'date', linha: 3, required: false, visible: true, subLabel: 'Quem estava com o veículo nesta data' },
    {
      coluna: 2, label: 'Apenas com opção de compra', largura: 6, nome: 'opcaoDeCompra', tipo: 'checkbox', linha: 3, required: false, visible: true
    },
    {
      label: '', nome: '_toggleAvancadoLocacao', tipo: 'custom', required: false,
      largura: 12, coluna: 1, linha: 4, visible: true,
      component: () => (
        <button
          type="button"
          onClick={() => setMostrarAvancadoRelatorio(!mostrarAvancadoRelatorio)}
          style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
        >
          {mostrarAvancadoRelatorio ? 'Ocultar opções avançadas' : 'Mostrar filtros avançados'}
        </button>
      ),
    },
    {
      coluna: 1, label: 'Unidade', largura: 6, nome: 'filiais', tipo: 'multiselect', selectBoxIsCleareable: true, linha: 5, required: false,
      visible: () => mostrarAvancadoRelatorio && empresaTemFiliais,
      selectMultiProps: {
        dataSource: filiaisOptions.map(f => ({ id: f.valor, nome: f.label })),
        onSelectionChange: ((data: any) => {
          setFiliaisEscolhidas(data);
        }),
        optionLabelField: 'nome',
        height: '200px',
        modo: TipoFormulario.tpCadastro,
        initialSelected: [],
        criticarRepeticao: true,
        orderByField: "nome",
        multiValueBackground: "#1F467E",
      },
    },
  ] : relatorio === TpRelatorioGeral.Veiculo ? [
    { coluna: 1, label: 'Data Compra Inicial', largura: 6, nome: 'dataInicial', tipo: 'date', linha: 1, required: false, visible: true },
    { coluna: 2, label: 'Data Compra Final', largura: 6, nome: 'dataFinal', tipo: 'date', linha: 1, required: false, visible: true },
    { coluna: 1, label: 'Valor Investido inicial', largura: 6, nome: 'valorInicial', tipo: 'money', linha: 2, required: false, visible: true },
    { coluna: 2, label: 'Valor Investido final', largura: 6, nome: 'valorFinal', tipo: 'money', linha: 2, required: false, visible: true },
    {
      coluna: 1, label: 'Situação', largura: 6, nome: 'situacao', tipo: 'select', selectBoxIsCleareable: true, linha: 3, required: false, visible: true, opcoes: [
        { label: ConverterEscolhaRelatorioVeiculosSituacaoParaTexto(TpEscolhaRelatorioVeiculosSituacao.Todos), valor: TpEscolhaRelatorioVeiculosSituacao.Todos },
        { label: ConverterEscolhaRelatorioVeiculosSituacaoParaTexto(TpEscolhaRelatorioVeiculosSituacao.Ativo), valor: TpEscolhaRelatorioVeiculosSituacao.Ativo },
        { label: ConverterEscolhaRelatorioVeiculosSituacaoParaTexto(TpEscolhaRelatorioVeiculosSituacao.Parado), valor: TpEscolhaRelatorioVeiculosSituacao.Parado },
        { label: ConverterEscolhaRelatorioVeiculosSituacaoParaTexto(TpEscolhaRelatorioVeiculosSituacao.Vendido), valor: TpEscolhaRelatorioVeiculosSituacao.Vendido },
        { label: ConverterEscolhaRelatorioVeiculosSituacaoParaTexto(TpEscolhaRelatorioVeiculosSituacao.Roubado), valor: TpEscolhaRelatorioVeiculosSituacao.Roubado },
        { label: ConverterEscolhaRelatorioVeiculosSituacaoParaTexto(TpEscolhaRelatorioVeiculosSituacao.Inativo), valor: TpEscolhaRelatorioVeiculosSituacao.Inativo },
      ]
    },
    {
      coluna: 2, label: 'Modo de Visualização', largura: 6, nome: 'modoVisualizacao', tipo: 'select', selectBoxIsCleareable: true, linha: 3, required: false, visible: true,
      opcoes: [
        { label: "Compacto", valor: TipoModoVisualizacaoRelatorio.Compacto },
        { label: "Detalhado", valor: TipoModoVisualizacaoRelatorio.Detalhado },
      ], apenasLeitura: false, onCampoSair(e: TipoModoVisualizacaoRelatorio) {
        setModoVisualizacaoRelatorio(e)
      },
    },
    {
      coluna: 1, label: 'Final da placa', largura: 6, nome: 'finalPlaca', tipo: 'text', linha: 4, required: false, visible: true, maximoCaracteres: 7, tudoMaiusculo: true,
      subLabel: 'Traz placas terminadas no que for digitado (ex.: 5)'
    },
    {
      label: '', nome: '_toggleAvancadoVeiculo', tipo: 'custom', required: false,
      largura: 12, coluna: 1, linha: 5, visible: true,
      component: () => (
        <button
          type="button"
          onClick={() => setMostrarAvancadoRelatorio(!mostrarAvancadoRelatorio)}
          style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
        >
          {mostrarAvancadoRelatorio ? 'Ocultar opções avançadas' : 'Mostrar filtros avançados'}
        </button>
      ),
    },
    {
      coluna: 1, label: 'Unidade', largura: 6, nome: 'filiais', tipo: 'multiselect', selectBoxIsCleareable: true, linha: 6, required: false,
      visible: () => mostrarAvancadoRelatorio && empresaTemFiliais,
      selectMultiProps: {
        dataSource: filiaisOptions.map(f => ({ id: f.valor, nome: f.label })),
        onSelectionChange: ((data: any) => {
          setFiliaisEscolhidas(data);
        }),
        optionLabelField: 'nome',
        height: '200px',
        modo: TipoFormulario.tpCadastro,
        initialSelected: [],
        criticarRepeticao: true,
        orderByField: "nome",
        multiValueBackground: "#1F467E",
      },
    },
  ] : [];

  const handleBuscarRelatorioServicoVeiculo = async (e: any) => {
    const novaDataInicial = formatarData(new Date(e['dataInicial']));
    const novaDataFinal = formatarData(new Date(e['dataFinal']));
    const veiculoLabel = veiculosOpcoes.find(v => v.valor == e['idVeiculo'])?.label;
    const novoVeiculo = veiculoLabel ? veiculoLabel.replace(':', ' -') : 'TODOS';
    setDataInicial(novaDataInicial);
    setDataFinal(novaDataFinal);
    setVeiculo(novoVeiculo);
    await buscarRelatorioServicoVeiculo(e);
  };

  const handleBuscarRelatorioLocacoes = async (e: any) => {
    const novaDataInicial = e['dataInicial'] ? formatarData(new Date(e['dataInicial'])) : '';
    const novaDataFinal = e['dataFinal'] ? formatarData(new Date(e['dataFinal'])) : '';
    const veiculoLabel = veiculosOpcoes.find(v => v.valor == e['idVeiculo'])?.label;
    const novoVeiculo = veiculoLabel ? veiculoLabel.replace(':', ' -') : 'TODOS';
    setStatusLocacao(converterStatusLocacaoParaTexto(e['status']) || 'TODOS');
    setDataInicial(novaDataInicial);
    setDataFinal(novaDataFinal);
    setVeiculo(novoVeiculo);
    await buscarRelatorioLocacoes(e);
  };

  const handleBuscarRelatorioVeiculos = async (e: any) => {
    const novaDataInicial = e['dataInicial'] ? formatarData(new Date(e['dataInicial'])) : '';
    const novaDataFinal = e['dataFinal'] ? formatarData(new Date(e['dataFinal'])) : '';
    const valorInicial = Number(e['valorInicial']);
    const valorFinal = Number(e['valorFinal']);
    setValorInicial(valorInicial);
    setValorFinal(valorFinal);
    setDataInicial(novaDataInicial);
    setDataFinal(novaDataFinal);
    setSituacao(e['situacao']);
    await buscarRelatorioVeiculos(e);
  };

  const onOpenContexto = async () => {
    if (relatorio == TpRelatorioGeral.ServicoVeiculo) {
      await fetchVeiculos();
      await fetchPrestadorServico();
    } else if (relatorio == TpRelatorioGeral.Locacao) {
      await fetchVeiculos();
    }

    setTimeout(() => {
      const defaults: any = {
        modoVisualizacao: TipoModoVisualizacaoRelatorio.Detalhado,
        situacao: TpEscolhaRelatorioVeiculosSituacao.Todos,
      };
      // Veículos e Locação têm datas opcionais: deixar vazias por padrão (não preencher).
      if (relatorio !== TpRelatorioGeral.Veiculo && relatorio !== TpRelatorioGeral.Locacao) {
        defaults.dataInicial = formatDateToISOWithZeroTime(dataMesAnterior);
        defaults.dataFinal = formatDateToISOWithZeroTime(new Date());
      }
      setEntidadeAtualizacao(defaults);
      setForcarAtualizacao(true);
    }, 50);
  };

  useEffect(() => {
    const fetchLocacoesParaLaudo = async () => {
      try {
        const resp = await api.get(`/LocacaoPorEmpresaSemPaginacao/${obterIdTenent(token)}`);
        const opcoes = (resp.data || []).map((loc: any) => ({
          valor: loc.id,
          label: `${loc.veiculo?.placa || ''} - ${loc.locatario?.nome || ''}`,
          dados: loc,
        }));
        setLocacoesParaLaudo(opcoes);
      } catch { }
    };
    fetchLocacoesParaLaudo();
  }, [token]);

  useEffect(() => {
    if (forcarAtualizacao) {
      setForcarAtualizacao(false);
    }
  }, [forcarAtualizacao]);

  const handleAplicarFiltro = (tpRelatorio: TpRelatorioGeral) => {
    setRelatorio(tpRelatorio);
    setExibirContexto(true);
  };

  const configuracaoBanda: ConfiguracaoBanda = {
    mestre: {
      colunas: colunasRelatorio
    },
  };

  if (relatorio === TpRelatorioGeral.ServicoVeiculo) {
    configuracaoBanda.detalhes = [
      {
        nome: "Serviços",
        propriedadeDados: "servicos",
        colunas: [
          { titulo: "Valor", propriedade: "servico.valor" },
          { titulo: "Nome", propriedade: "servico.nome" },
        ],
      },
      {
        nome: "Peças/Itens",
        propriedadeDados: "pecas",
        colunas: [
          { titulo: "Marca", propriedade: "peca.marca" },
          { titulo: "Modelo", propriedade: "peca.modelo" },
          { titulo: "Nome", propriedade: "peca.nome" },
          { titulo: "Origem Estoque", propriedade: "provenienteDoEstoque" },
          { titulo: "Qtd", propriedade: "quantidadeUsada" },
          { titulo: "Vr Un", propriedade: "valorUnidade" },
          { titulo: "Vr Total", propriedade: "valor" },
        ],
      },
    ];
  }

  return (
    <LocaSmartLayout>
      <Title>
        Geral:
      </Title>

      <ContainerRelatorioCard>
        <RelatorioCard
          titulo="Manutenções Realizadas"
          subtitulo="Relatório de Serviços por veículo irá listar as Manutenções Realizadas em um determinado veículo."
          onAplicarFiltros={() => handleAplicarFiltro(TpRelatorioGeral.ServicoVeiculo)}
          corBotao="#00d9ff"
        />
        <RelatorioCard
          titulo="Locações"
          subtitulo="Relatório de Locações apresenta a lista de locações realizadas dentro de um período específico."
          onAplicarFiltros={() => handleAplicarFiltro(TpRelatorioGeral.Locacao)}
          corBotao="#2ECBA6"
        />
        <RelatorioCard
          titulo="Veículos"
          subtitulo="O Relatório de Veículos exibe a lista completa dos veículos da frota da sua locadora."
          onAplicarFiltros={() => handleAplicarFiltro(TpRelatorioGeral.Veiculo)}
          corBotao="#2C3E50"
        />
        <RelatorioCard
          titulo="Laudo da Locação"
          subtitulo="Relatório completo com dados da locação, financeiro, multas, manutenções, vistorias e mais."
          onAplicarFiltros={() => {
            if (locacoesParaLaudo.length === 0) {
              toast.info('Nenhuma locação encontrada.');
              return;
            }
            setShowLaudoLocacao(true);
          }}
          corBotao="#1E3A5F"
        />
      </ContainerRelatorioCard>

      <Relatorio
        trigger={reportTrigger}
        titulo={tituloRelatorio}
        rodape={rodapeRelatorio}
        fonteDeDados={fonteDeDados}
        subtitulo={subTituloRelatorio}
        usuario={obterNomeUsuario(token)}
        empresa={obterNomeEmpresa(token)}
        configuracaoBanda={configuracaoBanda}
        modoCompacto={modoVisualizacaoRelatorio == TipoModoVisualizacaoRelatorio.Compacto}
        formato={formatoRelatorio}
      />

      <ModalForm
        urlTutorial={relatorio == TpRelatorioGeral.ServicoVeiculo ? "https://youtu.be/fDtPGYH77So" : ""}
        campos={contexto}
        onShow={onOpenContexto}
        carregando={false}
        modo={TipoFormulario.tpCadastro}
        titulo={"Gerar Relatório: " + tituloRelatorio}
        tituloBotaoOk="Gerar"
        apiConfig={{
          endpoint: '',
          idTenentCampo: 'idEmpresa',
          requisicaoBemSucedida: () => { toast.success('Relatório gerado com sucesso.') },
          tratarErro: () => { },
        }}
        onSave={onSave}
        onCancel={() => setExibirContexto(false)}
        onHide={() => setExibirContexto(false)}
        show={exibirContexto}
        tamanho="lg"
        atualizacaoEntidade={{
          entidadeUsadaParaAtualizacao: entidadeAtualizacao,
          forcarAtualizacao: forcarAtualizacao
        }}
      />

      <ModalEscolhaFormatoRelatorio
        open={exibirEscolhaFormato}
        onClose={() => setExibirEscolhaFormato(false)}
        onConfirmar={dispararGeracaoRelatorio}
      />

      <ProgressBarModal
        carregando={carregando}
        titulo="Carregando relatório..."
      />
      {showLaudoLocacao && !locacaoParaLaudo && (
        <ModalAlertaLaudo
          show={true}
          locacoes={locacoesParaLaudo}
          onClose={() => setShowLaudoLocacao(false)}
          onSelecionar={async (idLocacao: string) => {
            try {
              const resp = await api.get(`/Locacao/${idLocacao}`);
              setLocacaoParaLaudo(resp.data);
            } catch {
              toast.error('Erro ao buscar dados da locação');
            }
          }}
        />
      )}

      <ModalRelatorioLocacao
        show={!!locacaoParaLaudo}
        onClose={() => { setLocacaoParaLaudo(null); setShowLaudoLocacao(false); }}
        locacao={locacaoParaLaudo}
      />
    </LocaSmartLayout>
  );
}

export default RelatorioGeral;